import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商品名称", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'prod-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: [String, Number],
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        prodName.value = '';
        selectedList.value = [...props.selectedList]; // table.value.commitProxy('reload')
      }
    });
    const table = ref();
    const tableData = ref([]);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '商品名称',
        field: 'prodName'
      }, {
        title: '商品规格',
        field: 'prodSpecification'
      }, {
        title: '分销商名称',
        field: 'branchName'
      }, {
        title: '生产厂家',
        field: 'manufacture'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              supplierId: props.supplierId,
              prodName: prodName.value
            };
            Axios.get('/admin/split/rule/supplierMerchandiseList.json', {
              params
            }).then(res => {
              let {
                success,
                data
              } = res.data;
              tableData.value = data.list;

              if (success) {
                resolve({
                  total: data.total,
                  result: data.list
                });

                if (selectedList.value.length) {
                  setTimeout(() => {
                    let selectedRows = data.list.filter(item => selectedList.value.find(v => v.prodNo == item.prodNo));
                    table.value.setCheckboxRow(selectedRows, true);
                  }, 300);
                }
              }
            });
          })
        }
      }
    });
    const prodName = ref('');

    function reset() {
      prodName.value = '';
      table.value.commitProxy('reload');
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      let {
        row,
        checked
      } = e;
      let findIndex = selectedList.value.findIndex(v => v.prodNo == row.prodNo);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.prodNo == item.prodNo)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          // console.log(item)
          let findIndex = selectedList.value.findIndex(v => v.prodNo === item.prodNo);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function submit() {
      emits('success', selectedList.value);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "商品列表",
        width: "80%",
        top: "5vh",
        "custom-class": "setting-prod-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: prodName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prodName.value = $event),
          placeholder: "请输入商品名称"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })])]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};